var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"market-settings-button",class:{
    'market-settings-button--disabled': _vm.disabled,
    'market-settings-button--theme-details': _vm.theme === 'details',
  },attrs:{"aria-label":"Open Trade Experience Settings"},on:{"click":_vm.onToggle}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cc282c3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/market/market-settings-button/market-settings-button.vue
// module id = HQPR
// module chunks = 65